import { defineStore } from 'pinia'
import news from '@/data/landing/news.json'

export const useNewsStore = defineStore('news', {
	state: () => ({
		news: []
	}),
	getters: {},
	actions: {
		fetchNews() {
			this.news = news || []
		}
	}
})
